/* eslint-disable */
import { getHost } from '@/services/system-service';
import { getVoiceNodes } from '@/services/voice-service';
import store from '@/store';
import Janus from '@/weon/web-rtc/janus.js';
import { resetVoiceConnection } from '@/shared/utils/connection.js';
import { setFavIconByStatus } from '@/shared/utils/favicon.js';
import { notify } from '@/shared/utils/browser-notify';
import i18n from '@/i18n';

Janus.init({ debug: true });
window.webRTCReconnectionRetries = 0;
window.jsep = null;

/**
 * connectWebRTC
 * Realiza a conexão webRTC com o janusServer
 * @param {*} agentId
 * @param {*} orgUnitId
 */
export const connectWebRTC = async (agentId, orgUnitId) => {
  if (
    store.state._connection.connectionWebRTCStatus == 'connected' ||
    store.state._connection.connectionWebRTCStatus == 'reconnecting'
  ) {
    console.log('[WEBRTC][CONNECTION/NEW-CONNECTION] - Já conectado.');
    store.dispatch('_connection/setConnectionWebRTCStatus', 'connected');
    return;
  }

  if (store.state._connection.connectionWebRTCStatus == 'connection-lost') {
    store.dispatch('_connection/setConnectionWebRTCStatus', 'reconnecting');
  }

  if (
    window.weonWebRTC != undefined &&
    window.weonWebRTC.hasOwnProperty('session')
  ) {
    await window.weonWebRTC.session.destroy();
  }
  console.log(
    '[WEBRTC][CONNECTION/NEW-CONNECTION] - Nova conexão Weon WebRTC ',
  );

  let janusConfig = null;

  if (janusConfig == null) {
    janusConfig = await setupJanusConnectInformation(agentId, orgUnitId);
  }

  window.janusInstance = new Janus({
    server: janusConfig.server,
    apisecret: janusConfig.apisecret,
    iceServers: [
      {
        url: 'stun:stun.weon.com.br:3478',
        username: 'weon',
        credential: '%5$41s0lv3',
      },
      {
        url: 'turn:turn.weon.com.br:5349',
        username: 'weon',
        credential: '%5$41s0lv3',
      },
    ],
    ipv6: false,
    keepAlivePeriod: 8000,
    success: await function () {
      window.janusInstance.attach({
        plugin: janusConfig.plugin,
        success: function (pluginHandle) {
          window.weonWebRTC = pluginHandle;
          window.weonWebRTC.send({
            message: {
              authuser: janusConfig.authuser,
              display_name: janusConfig.display_name,
              proxy: janusConfig.proxy,
              request: janusConfig.request,
              secret: janusConfig.secret,
              username: janusConfig.username,
            },
          });
        },
        mediaState: (msg, on) => {
          console.log('Media state', msg, on);

          if (on === false) {
            store.dispatch('channel/setLatestStatusBeforeDisconnect');
            store.dispatch('channel/setDisconnectVoiceChannel');
            setFavIconByStatus('offline');
            store.dispatch('_connection/setLostDeviceConnectionDialog', true);
            store.dispatch(
              '_connection/setConnectionWebRTCStatus',
              'disconnected',
            );
            endWebRTCSession();
          }
        },
        error: function (cause) {
          console.log(cause);
        },
        webrtcState: function (currentStatus, reason) {
          console.log('WEBRTCSTATE: ', currentStatus, reason);
        },
        iceState: async function (currentStatus) {
          switch (currentStatus) {
            case 'new':
              console.log('[WEBRTC][ICE][NEW]');
              break;
            case 'checking':
              console.log('[WEBRTC][ICE][CHECKING]');
              break;
            case 'connected':
              console.log('Connected to Janus server');
              console.log('[WEBRTC][ICE][CONNECTED]');
              store.dispatch('_connection/lostWebRTCConnection', false);
              store.dispatch(
                '_connection/setConnectionWebRTCStatus',
                'connected',
              );
              setFavIconByStatus('default');
              window.webRTCReconnectionRetries = 0;
              break;
            case 'completed':
              console.log('[WEBRTC][ICE][COMPLETED]');
              store.dispatch('_connection/lostWebRTCConnection', false);
              window.webRTCReconnectionRetries = 0;
              setFavIconByStatus('default');
              store.dispatch(
                '_connection/setConnectionWebRTCStatus',
                'connected',
              );
              break;
            case 'failed':
              console.log('[WEBRTC][ICE][FAILED]');
              break;
            case 'disconnected':
              console.log('[WEBRTC][ICE][DISCONNECTED]');

              startReconnectionProcess();

              const notification = {
                title: 'Conexão de voz perdida',
                body: 'Tentando se reconectar novamente',
                phoneNumber: '',
              };

              notify(notification, true, 'voiceWebrtcProblem');

              break;
            case 'closed':
              console.log('[WEBRTC][ICE][CLOSED]');
              break;
          }
        },
        ondata: function (stream) {
          console.log('ondata', stream);
        },
        ondataopen: function (stream) {
          console.log('ondataopen', stream);
        },
        onlocalstream: function (stream) {
          Janus.debug(' ::: Got a local stream :::', stream);
        },
        onremotestream: (stream) => {
          const element = document.getElementById('audio_remote');

          Janus.attachMediaStream(element, stream);
        },
        onmessage: async (msg, jsep) => {
          let result = msg['result'];

          if (jsep !== undefined) {
            console.log('jsep', jsep);
          }
          if (result !== null && result !== undefined) {
            let event = result['event'];
            if (event !== undefined && event !== null) {
              if (event === 'registered') {
                registerExten(agentId, janusConfig.authuser);
              }
              if (event === 'accepted') {
                // Call can start, now: handle the remote answer
                if (jsep) {
                  window.weonWebRTC.handleRemoteJsep({ jsep: jsep });
                }
                window.weonWebRTC.callId = msg['call_id'];
              }
              if (event === 'incomingcall') {
                window.jsep = jsep;
                connectOnAgentChannel(jsep);
                if (event === 'progress') {
                  if (jsep) {
                    window.weonWebRTC.handleRemoteJsep({ jsep: jsep });
                  }
                }
                if (event === 'accepted') {
                  if (jsep) {
                    window.weonWebRTC.handleRemoteJsep({ jsep: jsep });
                  }
                }

                if (event === 'updatingcall') {
                  console.log('Got re-INVITE');
                  let doAudio = jsep.sdp.indexOf('m=audio ') > -1;

                  window.weonWebRTC.createAnswer({
                    jsep: jsep,
                    media: { audio: doAudio, video: false },
                    success: function (jsep) {
                      var body = { request: 'update' };
                      window.weonWebRTC.send({ message: body, jsep: jsep });
                    },
                    error: function (error) {
                      console.log('WebRTC error:', error);
                      console.log('WebRTC error... ' + error.message);
                    },
                  });
                }
              }
            }
          }
        },
        oncleanup: function () {},
        detached: function () {},
      });
    },
    error: await function (cause) {
      console.error('[WEON-WEBRTC-WEBSOCKET-ERROR] - ', cause);
      startReconnectionProcess();
    },
    destroyed: await function () {},
  });
};

export const getWebRTCStats = async () => {
  // Get the statistics report from the peer connection

  if (
    window.weonWebRTC == null ||
    !Object.hasOwn(window.weonWebRTC, 'webrtcStuff')
  ) {
    console.log('[WEBRTC][STATS] - WebRTC não está conectado.');
    return null;
  }

  const peerConnection = window.weonWebRTC.webrtcStuff.pc;
  const stats = await peerConnection.getStats();

  // Initialize variables to store the stats
  let rtt = 0;
  let jitter = 0;
  let packetsLost = 0;
  let totalPackets = 0;

  stats.forEach((report) => {
    if (report.type === 'outbound-rtp' && !report.isRemote) {
      // Outbound RTP stream stats
      if (report.roundTripTime) {
        rtt = report.roundTripTime;
      }
      if (report.jitter) {
        jitter = report.jitter;
      }
      if (report.packetsSent && report.packetsLost) {
        packetsLost = report.packetsLost;
        totalPackets = report.packetsSent + report.packetsLost;
      }
    } else if (
      report.type === 'remote-inbound-rtp' &&
      report.kind === 'audio'
    ) {
      // Inbound RTP stream stats
      if (report.jitter) {
        jitter = report.jitter;
      }
      if (report.packetsLost) {
        packetsLost = report.packetsLost;
      }
      if (report.roundTripTime) {
        rtt = report.roundTripTime;
      }
    }
  });

  let packetLossPercentage = totalPackets
    ? (packetsLost / totalPackets) * 100
    : 0;

  console.log('[WEBRTC][STATS] - WebRTC está conectado.');
  return {
    rtt: parseFloat(rtt * 1000).toFixed(0) + 'ms',
    jitter: parseFloat(jitter * 1000).toFixed(0) + 'ms',
    packetLossPercentage: parseFloat(packetLossPercentage).toFixed(0) + '%',
  };
};

/**
 * startReconnectionProcess
 * Inicia o processo de reconexão
 */
const startReconnectionProcess = async () => {
  store.dispatch('_connection/lostWebRTCConnection', true);
  store.dispatch('channel/setLatestStatusBeforeDisconnect');
  store.dispatch('channel/setDisconnectVoiceChannel');
  store.dispatch('_connection/setConnectionWebRTCStatus', 'connection-lost');
  setFavIconByStatus('offline');
  resetVoiceConnection();
};

/**
 * setupJanusConnectInformation
 * Configuração dos dados necessários para realizar a conexão com o janusServer
 * @param {*} agentId
 * @param {*} orgUnitId
 * @returns Object
 */
const setupJanusConnectInformation = async (agentId, orgUnitId) => {
  const host = await getWeonHost();
  const asteriskNode = await getWeonAsteriskVoiceNode(agentId);

  return {
    server: `wss:${host}:8989`,
    apisecret: '%5$41s0lv3',
    authuser: 'agent-' + agentId + '-' + orgUnitId,
    display_name: 'agent-' + agentId + '-' + orgUnitId,
    proxy: `sip:${asteriskNode}:5060`,
    request: 'register',
    secret: `${agentId}`,
    username: `sip:agent-${agentId}-${orgUnitId}`,
    plugin: 'janus.plugin.sip',
  };
};

/**
 * getWeonHost
 * Busca a url do server para realizar a conexão via websocket
 * @returns String
 */
const getWeonHost = async () => {
  return await getHost().then((response) => {
    return response.WSS;
  });
};

/**
 * getWeonAsteriskVoiceNode
 * Busca a node de conexão disponível para o asterisk
 * @param {*} agentId
 * @returns String
 */
const getWeonAsteriskVoiceNode = async (agentId) => {
  const params = { agent_id: agentId };
  return await getVoiceNodes(params).then((response) => {
    return response.nodeWeonList[0].host;
  });
};

/**
 * endWebRTCSession
 * Finaliza a sessão do webRTC e limpa a variável
 */
export const endWebRTCSession = async () => {
  if (
    window.weonWebRTC != null &&
    window.weonWebRTC.hasOwnProperty('session')
  ) {
    await window.weonWebRTC.detach();
    await window.weonWebRTC.session.destroy();
    await window.janusInstance.destroy();
    window.janusInstance = null;
    window.weonWebRTC = null;
  }
};

/**
 * unRegisterExten
 * Finaliza a conexão do ramal que está sendo utilizado
 */
export const unRegisterExten = async (agentId, orgUnitId) => {
  console.log('[WEBRTC][UNREGISTER-EXTEN] - Desconectando ramal.');
  await window.weonWebRTC.send({
    message: {
      authuser: 'agent-' + agentId + '-' + orgUnitId,
      request: 'unregister',
    },
  });
};

/**
 * isWebRTCConnected
 * Verifica o estado da conexão de voz com o webRTC
 */
export const isWebRTCDown = () => {
  const downStatus = ['disconnected', 'failed', 'closed'];
  return downStatus.includes(window.weonWebRTC.webrtcStuff.pc.connectionState);
};

/**
 * muteMicrophone
 * Bloqueia o áudio do microfone
 */
export const muteMicrophone = () => {
  window.weonWebRTC.muteAudio();
};

/**
 * unMuteMicrophone
 * Desbloqueia o áudio do microfone
 */
export const unMuteMicrophone = () => {
  window.weonWebRTC.unmuteAudio();
};

/**
 * sendDTMF
 * Envio de DTMF via webRTC
 * @param {*} digit
 * @param {*} playAudio
 * @param {*} messageSuccess
 */
export const sendDTMF = (digit, playAudio, messageSuccess) => {
  const executeDTMF = () => {
    if (playAudio) {
      let dtmfAudio = new Audio(require('@/assets/dtmf.wav'));
      dtmfAudio.play();
    }

    window.weonWebRTC.dtmf({
      dtmf: { tones: digit.toString() },
      success: (value) => {
        console.log(messageSuccess);
      },
    });
  };

  const isDTMFTimeoutEnabled = (store?.state?.attendance?.Attendance?.systemConfig?.dtmfTimeoutEnabled && store?.state?.attendance?.Attendance?.systemConfig?.dtmfTimeoutEnabled === true);
  const dtmfTimeout = store?.state?.attendance?.Attendance?.systemConfig?.dtmfTimeout || 1500;

  if (digit === '#') {

    if (isDTMFTimeoutEnabled) {
      setTimeout(() => {
        executeDTMF();
      }, dtmfTimeout);
    } else {
      executeDTMF();
    }
  } else {

    if (isDTMFTimeoutEnabled) {
      setTimeout(() => {
        executeDTMF();
      }, dtmfTimeout);
    } else {
      executeDTMF();
    }
  }
};

/**
 * checkWebRTCVoiceChannelStatus
 * Verifica se o canal de voz está conectado de acordo com o tipo de conexão do agente
 * Modo é verificado pelo agentChannelEnabled
 * @returns Boolean
 */
export const checkWebRTCVoiceChannelStatus = () => {
  const agentChannelEnabled =
    store.state.attendance.Attendance.useAgentChannel === 'Y';

  if (agentChannelEnabled) {
    const isConnected =
      window.janusInstance != null &&
      window.janusInstance.isConnected() &&
      store.state.channel.channels.voice.status !== 'disconnected' &&
      window.weonWebRTC &&
      window.weonWebRTC.webrtcStuff.pc !== null &&
      window.weonWebRTC.webrtcStuff.iceDone;

    return isConnected;
  }

  const isConnected =
    window.janusInstance !== null &&
    window.janusInstance.isConnected() &&
    store.state.channel.channels.voice.status !== 'disconnected' &&
    window.weonWebRTC;

  return isConnected;
};

/**
 * Registra o ramal no janus
 * Comportamento padrão da ferramenta é utilizar o canal agente
 * @param {*} agentId
 * @param {*} exten
 * @returns
 */
const registerExten = (agentId, exten) => {
  const agentChannelEnabled =
    store.state.attendance.Attendance.useAgentChannel === 'Y';
  if (!agentChannelEnabled) {
    store.dispatch('_connection/lostWebRTCConnection', false);
    store.dispatch('_connection/setConnectionWebRTCStatus', 'connected');
    console.log(
      '[WEBRTC][REGISTER][AGENT-CHANNEL][DISABLED] - Agent channel não está habilitado.',
    );
    return;
  }

  console.log(
    '[WEBRTC][REGISTER][AGENT-CHANNEL][ENABLED] - Agent channel está habilitado.',
  );
  const paramsConnectChannel = { agentId: agentId, exten: exten };
  store.dispatch('channel/connectVoice', paramsConnectChannel);
};

/**
 * connectOnAgentChannel
 * Comportamento padrão da ferramenta é aceitar a chamada.
 * @param {*} jsep
 * @returns
 */
const connectOnAgentChannel = (jsep) => {
  const agentChannelEnabled =
    store.state.attendance.Attendance.useAgentChannel === 'Y';
  if (!agentChannelEnabled) {
    console.log(
      '[WEBRTC][REGISTERED][ANSWER-AGENT-CHANNEL][DISABLED] - Agent channel não está habilitado.',
    );
    return;
  }

  console.log(
    '[WEBRTC][REGISTER][AGENT-CHANNEL][ENABLED] - Agent channel está habilitado.',
  );
  window.weonWebRTC.createAnswer({
    jsep: jsep,
    media: {
      audioSend: true,
      audioRecv: true,
      audio: true,
      video: false,
    },
    success: (suc) => {
      var body = { request: 'accept' };
      window.weonWebRTC.send({ message: body, jsep: suc });
    },
    error: (err) => {
      console.log('errr', err);
      store.dispatch('_connection/setLostDeviceConnectionDialog', true);
      endWebRTCSession();
    },
  });
};

/**
 * webRTCAcceptCall
 * Aceita a chamada com base no modo de conexao de voz utilizado pelo agente
 */
export const webRTCAcceptCall = () => {
  const agentChannelEnabled =
    store.state.attendance.Attendance.useAgentChannel === 'Y';
  if (agentChannelEnabled) {
    console.log(
      '[WEBRTC][AGENTCHANNEL-MODE][ANSWER-CALL][DTMF] - Aceitando chamada via DTMF.',
    );
    sendDTMF('#', false, i18n.t('webRTC.dialpad.ackCallRequestAcceptCall'));
    return;
  }

  console.log(
    '[WEBRTC][SIP-MODE][ANSWER-CALL][CREATEANSWER] - Aceitando chamada via createAnswer.',
  );
  window.weonWebRTC.createAnswer({
    jsep: window.jsep,
    media: {
      audioSend: true,
      audioRecv: true,
      audio: true,
      video: false,
    },
    success: (suc) => {
      var body = { request: 'accept' };
      window.weonWebRTC.send({ message: body, jsep: suc });
      window.jsep = null;
    },
    error: (err) => {
      console.log('[WEBRTC][SIP-MODE][ACCEPT-CALL][ERROR]', err);
    },
  });
};

/**
 * webRTCRejectCall
 * Rejeita a chamada com base no modo de conexao de voz utilizado pelo agente
 */
export const webRTCRejectCall = () => {
  const agentChannelEnabled =
    store.state.attendance.Attendance.useAgentChannel === 'Y';
  if (agentChannelEnabled) {
    console.log(
      '[WEBRTC][AGENTCHANNEL-MODE][REJECT-CALL][DTMF] - Rejeitando chamada via DTMF.',
    );
    sendDTMF('*', false, i18n.t('webRTC.dialpad.ackCallRequestRejectCall'));
    return;
  }

  console.log(
    '[WEBRTC][SIP-MODE][REJECT-CALL][CREATEANSWER] - Rejeitando chamada via createAnswer.',
  );
  window.weonWebRTC.createAnswer({
    jsep: window.jsep,
    media: {
      audioSend: true,
      audioRecv: true,
      audio: true,
      video: false,
    },
    success: (suc) => {
      var body = { request: 'decline' };
      window.weonWebRTC.send({ message: body, jsep: suc });
      window.jsep = null;
    },
    error: (err) => {
      console.log('[WEBRTC][SIP-MODE][REJECT-CALL][ERROR]', err);
    },
  });
};